<template>
  <div>
    <div class="box term-row-compact box-50">
      <div class="term w-auto">
        <div class="term-item term-item-xl">
          {{ $t('src/components/training/trainingresults6mwt.2320') }}
        </div>
        <div class="term-value">{{ bloodPressureBeforeStr }}</div>
      </div>
      <div class="term w-auto">
        <div class="term-item term-item-xl">
          {{ $t('src/components/training/trainingresults6mwt.8069') }}
        </div>
        <div class="term-value">{{ bloodPressureAfterStr }}</div>
      </div>
      <div class="term w-auto">
        <div class="term-item term-item-xl">
          {{ $t('src/components/training/trainingresults6mwt.8713') }}
        </div>
        <div class="term-value">{{ saturationBeforeStr }}</div>
      </div>
      <div class="term w-auto">
        <div class="term-item term-item-xl">
          {{ $t('src/components/training/trainingresults6mwt.9337') }}
        </div>
        <div class="term-value">{{ saturationAfterStr }}</div>
      </div>
      <br />
      <div class="term w-auto">
        <div class="term-item term-item-xxl">
          {{ $t('src/components/training/trainingresults6mwt.distanceCovered') }}:
        </div>
        <div class="term-value d-flex">
          <template v-if="!isEditableCoveredDistance">
            {{ distanceStr }}
            <svg-icon
              v-if="isEditable"
              class="ml-2"
              :name="'edit_pen_inside_the_square'"
              :width="20"
              :height="20"
              @click:icon="openDistanceEditMode"
            ></svg-icon>
          </template>
          <template v-else>
            <div style="position: relative; ">
              <base-input
                v-model="localCoveredDistance"
                name="distanceCovered"
                style="height: 23px; width: 55px; padding: 0 5px;"
                :isNumber="true"
                :maxLength="3"
              >
              </base-input>
              <svg-icon
                v-if="isShowUndo"
                class="inside-el"
                :name="'undo_inside_the_square'"
                :width="15"
                :height="15"
                style="left: 35px; top: 3px"
                @click:icon="returnPreviousSavedDistance"
              ></svg-icon>
            </div>
            <svg-icon
              class="ml-2"
              :name="'tick_inside_the_square'"
              :width="20"
              :height="20"
              @click:icon="closeDistanceEditMode"
            ></svg-icon>
          </template>
        </div>
      </div>
      <div class="term w-auto">
        <div class="term-item term-item-xxl">
          {{ $t('src/components/training/trainingresults6mwt.predictedDistance') }}:
        </div>
        <div class="term-value">{{ enrightStr }}</div>
      </div>
      <div class="term w-auto">
        <div class="term-item term-item-xxl">
          {{ $t('src/components/training/trainingresults6mwt.percentagePredicted') }}:
        </div>
        <div class="term-value">{{ enrightPercentStr }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/modules/http.js'

export default {
  name: 'TrainingResults6MWT',
  components: {
    SvgIcon: () => import('@/components/SvgIcon.vue'),
    BaseInput: () => import('@/base/BaseInput.vue')
  },
  inject: ['$isEditableSession'],
  props: {
    bloodPressureBefore: {
      type: String,
      required: false
    },
    bloodPressureAfter: {
      type: String,
      required: false
    },
    saturationBefore: {
      type: String,
      required: false
    },
    saturationAfter: {
      type: String,
      required: false
    },
    distance: {
      type: Number,
      required: false
    },
    patient: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    localCoveredDistance: null,
    isEditableCoveredDistance: false
  }),

  computed: {
    trainingId() {
      return this.$route.params.id
    },
    bloodPressureBeforeStr() {
      if (!this.bloodPressureBefore) {
        return '–'
      }
      return this.bloodPressureBefore
    },
    bloodPressureAfterStr() {
      if (!this.bloodPressureAfter) {
        return '–'
      }
      return this.bloodPressureAfter
    },
    saturationBeforeStr() {
      if (!this.saturationBefore) {
        return '–'
      }
      return `${(+this.saturationBefore).toFixed(1)}%`
    },
    saturationAfterStr() {
      if (!this.saturationAfter) {
        return '–'
      }
      return `${(+this.saturationAfter).toFixed(1)}%`
    },
    distanceStr() {
      if (this.localCoveredDistance) return `${this.localCoveredDistance} ${this.$t('unit.m')}`
      else return '–'
    },
    enright() {
      let age = this.moment().diff(this.moment(this.patient.birth_date), 'years')
      if (Number.isInteger(this.patient.gender) && this.patient.height && this.patient.weight) {
        if (this.patient.gender === 0) {
          let res = 7.57 * this.patient.height - 5.02 * age - 1.76 * this.patient.weight - 309
          return Math.round(res)
        } else if (this.patient.gender === 1) {
          let res = 2.11 * this.patient.height - 2.29 * this.patient.weight - 5.78 * age + 667
          return Math.round(res)
        } else return null
      } else {
        return null
      }
    },
    enrightStr() {
      if (Number(this.enright) && Number(this.enright) > 0) {
        return `${this.enright} ${this.$t('unit.m')}`
      } else return '–'
    },
    enrightPercentStr() {
      if (Number.isInteger(this.enright) && Number(this.enright) > 0 && this.localCoveredDistance) {
        return `${Math.floor((this.localCoveredDistance * 100) / this.enright)}%`
      } else return '–'
    },
    isEditable() {
      return this.$isEditableSession()
    },
    isShowUndo() {
      return this.distance != this.localCoveredDistance
    }
  },

  created() {
    this.localCoveredDistance = this.distance
  },

  methods: {
    openDistanceEditMode() {
      this.isEditableCoveredDistance = true
    },
    closeDistanceEditMode() {
      this.saveCoveredDistance()
    },
    saveCoveredDistance() {
      http
        .patch('/trainings/' + this.trainingId, { distance: +this.localCoveredDistance })
        .then(() => {
          this.isEditableCoveredDistance = false
        })
        .catch(error => {
          if (error.response.data.message === 'The system has expired') {
            this.$emit('system:unavailable')
          }
          console.log(error)
        })
    },
    returnPreviousSavedDistance() {
      this.localCoveredDistance = this.distance
    }
  }
}
</script>
